import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import InverseProvider from '@dbk/ui-inverse';
import { TextArea } from '@dbk/ui-forms';

class ReportUnreadRMDocListItem extends PureComponent {

  // method to render report row
  renderReportRow = (item) => {
    const { i18n: { messages }, } = this.props;
    return (
      <div className="document-upload-reports-list-item-body">
        <Text style={{ display: "block", color: "#a7a8aa", fontSize: "16px" }} secondary>{messages['app.chedelivery.reports.messageFromRM']}</Text>
        <TextArea
          secondary
          className='message-to-client-dimension'
          maxlength={250}
          size="medium"
          multiline
          selectTextOnFocus={false}
          caretHidden={false}
          contextMenuHidden={false}
          readOnly
          value={item.msgToClient ? item.msgToClient : ''}
        />
      </div>
    )
  }

  render() {
    const { categoryReportList } = this.props;
    const dataForRendering = categoryReportList;
    return (
      <div className="large-12">
        <InverseProvider inverse style={{ width: "100%", display: "inline" }}>
          {this.renderReportRow(dataForRendering)}
        </InverseProvider>
      </div>
    );
  }
}

ReportUnreadRMDocListItem.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
};

ReportUnreadRMDocListItem.defaultProps = {
  i18n: {},
};
export default createContainer({
  $queries: {
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
  },
})(ReportUnreadRMDocListItem);

